/*
 * $Id:: index.js 2021/03/02 03:34 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useEffect, useState } from 'react';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import Card from '../../../../components/Card';
import { t } from '../../../../providers';
import { me as meSlice } from '../../../AuthenticatedPage/authenticationSlice';
import { SLICE_NAME } from '../../../AuthenticatedPage/constants';
import ChildAccountsTable from './ChildAccountsTable';
import FieldsMissingDialog from './FieldsMissingDialog';

const useStyles = makeStyles((theme) => ({
    headerSection: {
        paddingBottom: '30px',
    },
    cardTitle: {
        fontSize: '14px',
        fontWeight: '600',
        color: '#607D8B',
        marginTop: '10px',
    },
    addButton: {
        color: theme.palette.text.mainBlue,
        borderColor: theme.palette.text.mainBlue,
        borderRadius: '3px',
        height: '37px',
    },
    content: {
        marginTop: '3rem',
        marginBottom: '3rem',
    },
}));

const ChildAccounts = () => {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const me = useSelector(meSlice);

    const { impersonatedUser: readOnly } = me || {};

    const [dialogOpen, setDialogOpen] = useState(false);

    useEffect(() => {
        dispatch({ type: `${SLICE_NAME}/getUserinfo` });
    }, [dispatch]);

    const addAccount = (event) => {
        event.preventDefault();
        const isComplete = !!me && me.accountProfileCompleted;
        if (!isComplete) {
            setDialogOpen(true);
        } else {
            history.push('/child-accounts/create');
        }
    };

    const navigateToProfile = (event) => {
        event.preventDefault();
        setDialogOpen(false);
        history.push('/my-account/profile-details');
    };

    const cancelMessage = (event) => {
        event.preventDefault();
        setDialogOpen(false);
    };

    return (
        <React.Fragment>
            <Card canEdit={false}>
                <Grid justify={'space-between'} alignItems={'center'} container className={classes.headerSection}>
                    <Grid item>
                        <Typography className={classes.cardTitle}>{t('list.child.accounts')}</Typography>
                    </Grid>
                    <Grid item>
                        <Button className={classes.addButton} variant={'outlined'} onClick={addAccount} disabled={readOnly}>
                            {t('add.child.account')}
                        </Button>
                    </Grid>
                </Grid>
                <ChildAccountsTable />
            </Card>
            <FieldsMissingDialog open={dialogOpen} onAccept={navigateToProfile} onCancel={cancelMessage} />
        </React.Fragment>
    );
};

export default ChildAccounts;
